import React, { useState } from "react";
import { TextField, Button, FormControlLabel, Checkbox, Grid } from "@mui/material";
import { PMDialog } from "../../../utils/PMDialog";
import { useTranslation } from "react-i18next";

export const ContractLinesExportDialog = ({
  open,
  onClose,
  onExport,
}) => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState({
    format: "pdf",
    showLineDetails: true,
    showUnitPrice: true,
    showCompletedQuantity: true,
    showProgressPercentage: true,
    showGroupTotals: true,
    showOnlyGroups: false,
  });

  const handleExport = () => {
    onExport(settings);
  };

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title="Eksporter kontraktlinjer"
      size="lg"
      closeOnOutsideClick={false}
    >
      <div className="space-y-4">
        {/* Format */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Format
          </label>
          <select
            value={settings.format}
            onChange={(e) => setSettings({ ...settings, format: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="pdf">PDF</option>
            <option value="excel">Excel</option>
          </select>
        </div>

        {/* Show only groups */}
        <FormControlLabel
          control={
            <Checkbox
              checked={settings.showOnlyGroups}
              onChange={(e) => setSettings({ ...settings, showOnlyGroups: e.target.checked })}
            />
          }
          label="Vis kun grupper (skjul linjer)"
        />

        {!settings.showOnlyGroups && (
          <>
            {/* Show line details */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={settings.showLineDetails}
                  onChange={(e) => setSettings({ ...settings, showLineDetails: e.target.checked })}
                />
              }
              label="Vis linjedetaljer"
            />

            {/* Show unit price */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={settings.showUnitPrice}
                  onChange={(e) => setSettings({ ...settings, showUnitPrice: e.target.checked })}
                />
              }
              label="Vis enhetspris"
            />

            {/* Show completed quantity */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={settings.showCompletedQuantity}
                  onChange={(e) => setSettings({ ...settings, showCompletedQuantity: e.target.checked })}
                />
              }
              label="Vis utført mengde"
            />

            {/* Show progress percentage */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={settings.showProgressPercentage}
                  onChange={(e) => setSettings({ ...settings, showProgressPercentage: e.target.checked })}
                />
              }
              label="Vis fremdriftsprosent"
            />
          </>
        )}

        {/* Show group totals */}
        <FormControlLabel
          control={
            <Checkbox
              checked={settings.showGroupTotals}
              onChange={(e) => setSettings({ ...settings, showGroupTotals: e.target.checked })}
            />
          }
          label="Vis totalsum per gruppe"
        />

        {/* Actions */}
        <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
          <Button onClick={onClose}>
            {t("common.cancel")}
          </Button>
          <Button
            onClick={handleExport}
            variant="contained"
            className="bg-blue-600 hover:bg-blue-700"
          >
            Eksporter
          </Button>
        </div>
      </div>
    </PMDialog>
  );
};

